import * as React from "react";
import { useCallback } from "react";
import { PaginatedEntityTable } from "components/common";
import QueryHelper from "components/common/QueryHelper";
import { fetchSavedSearches, queryKey } from "views/hooks/useSavedSearches";
import useColumnRenderers from "views/components/searchbar/saved-search/useColumnRenderes";
import usePluggableEntityTableElements from "hooks/usePluggableEntityTableElements";
import { DEFAULT_LAYOUT } from "views/components/searchbar/saved-search/Constants";
import SearchActions from "./SearchActions";
import BulkActions from "../BulkActions";
const SavedSearchesOverview = ({ activeSavedSearchId, deleteSavedSearch, onLoadSavedSearch }) => {
  const { pluggableAttributes, pluggableExpandedSections } = usePluggableEntityTableElements(null, "search");
  const renderSavedSearchActions = useCallback(
    (search) => /* @__PURE__ */ React.createElement(
      SearchActions,
      {
        search,
        onDeleteSavedSearch: deleteSavedSearch,
        activeSavedSearchId
      }
    ),
    [activeSavedSearchId, deleteSavedSearch]
  );
  const customColumnRenderers = useColumnRenderers(onLoadSavedSearch);
  return /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      additionalAttributes: pluggableAttributes.attributes,
      bulkSelection: { actions: /* @__PURE__ */ React.createElement(BulkActions, null) },
      columnRenderers: customColumnRenderers,
      entityActions: renderSavedSearchActions,
      entityAttributesAreCamelCase: true,
      expandedSectionRenderers: pluggableExpandedSections,
      fetchEntities: fetchSavedSearches,
      focusSearchAfterMount: true,
      humanName: "Saved Searches",
      keyFn: queryKey,
      queryHelpComponent: /* @__PURE__ */ React.createElement(QueryHelper, { entityName: "search", commonFields: ["id", "title"] }),
      tableLayout: DEFAULT_LAYOUT,
      withoutURLParams: true
    }
  );
};
export default SavedSearchesOverview;
